import { Link } from "react-router-dom";
import { useState } from "react";
import { toast } from "react-toastify";
import { getErrorMessage } from "../../utils/getErrorMessage";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [isSubscribing, setIsSubscribing] = useState(false);
  const [mensNewsletter, setMensNewsletter] = useState(false);
  const [womensNewsletter, setWomensNewsletter] = useState(false);

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    setIsSubscribing(true);

    try {
      const res = await fetch("/api/newsletter", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ 
          email,
          interests: {
            mens: mensNewsletter,
            womens: womensNewsletter
          }
        }),
      });

      const data = await res.json();

      if (res.ok) {
        toast.success("Successfully subscribed to our newsletter!");
        setEmail("");
        setMensNewsletter(false);
        setWomensNewsletter(false);
      } else {
        toast.error(getErrorMessage(data, "Failed to subscribe. Please try again."));
      }
    } catch (err) {
      toast.error(getErrorMessage(err, "An error occurred. Please try again."));
    } finally {
      setIsSubscribing(false);
    }
  };

  return (
    <footer className="relative text-white">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://res.cloudinary.com/dwzlccpmu/image/upload/w_1920,q_auto,f_auto/v1770286440/footer-img_h5brni.webp')",
        }}
        aria-hidden="true"
      />

      {/* Content */}
      <div className="relative z-10 mx-auto pt-7 sm:pt-16 pb-7">
        {/* Headline - Animated Carousel */}
        <div className="footer-carousel-outer px-4 mb-8 sm:mb-12">
          <div className="footer-carousel-inner">
            <span className="footer-carousel-text">
              SHOP WITH US TODAY, SHOP WITH TRULIXX FASHION. | THE LATEST TRENDS | EXCLUSIVE OFFERS | PREMIUM WEARS | FAST DELIVERY |
            </span>
            <span className="footer-carousel-text">
              SHOP WITH US TODAY, SHOP WITH TRULIXX FASHION. | THE LATEST TRENDS | EXCLUSIVE OFFERS | PREMIUM WEARS | FAST DELIVERY |
            </span>
            <span className="footer-carousel-text">
              SHOP WITH US TODAY, SHOP WITH TRULIXX FASHION. | THE LATEST TRENDS | EXCLUSIVE OFFERS | PREMIUM WEARS | FAST DELIVERY |
            </span>
          </div>
        </div>

        {/* Newsletter Bar */}
        <div className="border-t border-b border-[#E0DFDD] grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 items-start md:items-center mb-8 md:mb-12 lg:mb-16 min-h-auto md:min-h-20 px-4 md:px-6 lg:px-8 py-6 md:py-4 lg:py-0">
          <div className="border-b md:border-b-0 md:border-r border-[#E0DFDD] pb-4 md:pb-0 h-full flex items-center justify-center">
            <img
              src="/images/logo/logo.png"
              alt=""
              className="w-[100px] h-[52px]"
              aria-hidden="true"
            />
          </div>

          {/* Text */}
          <p className="text-sm sm:text-sm md:col-span-1 text-white/80 w-full">
            SIGN UP TO OUR NEWSLETTER <br />
            FOR EXCELLENT OFFERS
          </p>

          {/* Interests */}
          <fieldset className="flex flex-col sm:flex-row gap-3 md:gap-2 text-sm sm:text-sm w-full md:col-span-1">
            <legend className="whitespace-nowrap">I'M INTERESTED IN:</legend>
            <div className="flex gap-4 flex-wrap">
              <label className="flex items-center gap-2">
                <input 
                  type="checkbox" 
                  checked={mensNewsletter}
                  onChange={(e) => setMensNewsletter(e.target.checked)}
                  className="accent-white" 
                /> Mens Newsletter
              </label>
              <label className="flex items-center gap-2">
                <input 
                  type="checkbox" 
                  checked={womensNewsletter}
                  onChange={(e) => setWomensNewsletter(e.target.checked)}
                  className="accent-white" 
                /> Womens Newsletter
              </label>
            </div>
          </fieldset>

          {/* Email */}
          <form onSubmit={handleNewsletterSubmit} className="flex flex-col sm:flex-row gap-2 w-full md:col-span-1">
            <label htmlFor="footer-email" className="sr-only">
              Email address
            </label>
            <input
              id="footer-email"
              type="email"
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={isSubscribing}
              className="w-full bg-transparent border border-[#E0DFDD] px-3 sm:px-4 py-2 text-sm sm:text-sm focus:outline-none focus:ring-1 focus:ring-white disabled:opacity-50"
              aria-label="Email address for newsletter"
            />
            <button
              type="submit"
              disabled={isSubscribing}
              className="bg-white text-black px-4 sm:px-6 py-2 text-sm sm:text-sm font-medium hover:bg-gray-200 transition whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
              aria-label="Subscribe to newsletter"
            >
              {isSubscribing ? "Subscribing..." : "Submit"}
            </button>
          </form>
        </div>

        {/* Footer Links */}
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-10 text-sm sm:text-sm px-4 sm:px-8 my-8 sm:my-0">
          {/* Socials */}
          <div>
            <h3 className="mb-3 sm:mb-4 font-semibold text-sm sm:text-base">
              SOCIALS
            </h3>
            <ul className="space-y-2 text-white/80 text-sm sm:text-sm">
              <li>
                <a
                  href="https://www.instagram.com/trulixx_fashion?igsh=Y2VtZXpiMWh2ZnRk"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition"
                >
                  Instagram
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/share/1KJwMnAHQo/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition"
                >
                  Facebook
                </a>
              </li>
            </ul>
          </div>

          {/* Shop */}
          <div>
            <h3 className="mb-3 sm:mb-4 font-semibold text-sm sm:text-base">
              SHOP
            </h3>
            <ul className="space-y-2 text-white/80 text-sm sm:text-sm">
              <li>
                <Link to="/men" className="hover:text-white transition">
                  Men's Collection
                </Link>
              </li>
              <li>
                <Link to="/women" className="hover:text-white transition">
                  Women's Collection
                </Link>
              </li>
              <li>
                <Link to="/kids" className="hover:text-white transition">
                  Kids
                </Link>
              </li>
              <li>
                <Link to="/" className="hover:text-white transition">
                  Best Sellers
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="mb-3 sm:mb-4 font-semibold text-sm sm:text-base">
              QUICK LINKS
            </h3>
            <ul className="space-y-2 text-white/80 text-sm sm:text-sm">
              <li>
                <Link
                  to="/privacy-policy"
                  className="hover:text-white transition"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms-and-conditions"
                  className="hover:text-white transition"
                >
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link
                  to="/return-policy"
                  className="hover:text-white transition"
                >
                  Returns & Exchange
                </Link>
              </li>
              <li>
                <Link to="/support" className="hover:text-white transition">
                  Support
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="mb-3 sm:mb-4 font-semibold text-sm sm:text-base">
              CONTACT US
            </h3>
            <ul className="space-y-2 text-white/80 text-sm sm:text-sm">
              <li>Ego Uwajeh Street, Asaba, Delta State, Nigeria</li>
              <li>+234 8119648842</li>
              <li>
                <a
                  href="mailto:Sales@Trulixx.com"
                  className="hover:text-white transition"
                  onClick={(e) => e.stopPropagation()}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Sales@Trulixx.com
                </a>
              </li>
              <li>
                <a
                  href="mailto:Support@Trulixx.com"
                  className="hover:text-white transition"
                  onClick={(e) => e.stopPropagation()}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Support@Trulixx.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#E0DFDD] mt-8 sm:mt-12 pt-4 sm:pt-6 flex flex-col sm:flex-row justify-between gap-4 text-sm text-white/60 px-4 sm:px-8 pb-4">
          <span>© 2024 Trulixx.com. All rights reserved.</span>
          <span>Trulixx Fashion is a product of Phiyorbyte Ltd.</span>
        </div>
      </div>
    </footer>
  );
}